export default __webpack_public_path__ + "static/media/Study abroad-pana.b73644e7.svg";